import { connect, ConnectedProps } from "react-redux";
import { PayFlexSurvey } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getApplicableCredit,
  getPricingInfoFlightTotalInPrices,
  getPayFlexCardProductUsed,
  getTotalCreditCardPaymentRequiredNumber,
  getRewardsPaymentInFiatCurrency,
} from "../../reducer";

const mapStateToProps = (state: IStoreState) => {
  const flightTotalInPrices = getPricingInfoFlightTotalInPrices(state);
  const rewardsPayment = getRewardsPaymentInFiatCurrency(state);
  const applicableCredit = getApplicableCredit(state);

  return {
    netCashValueP: getTotalCreditCardPaymentRequiredNumber(state) ?? 0,
    totalAmountUsd: flightTotalInPrices?.fiat.value ?? 0,
    rewardsAmountUsd: rewardsPayment?.value ?? 0,
    creditsAmountUsd: applicableCredit?.amount.amount ?? 0,
    cardProductUsed: getPayFlexCardProductUsed(state),
  };
};

const connector = connect(mapStateToProps);

export type PayFlexSurveyConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPayFlexSurvey = connector(PayFlexSurvey);
